import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetClaimHistoryDetailResponseDto } from "../../dtos/get-claim-history-detail-response-dto";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { OrderService } from "../../services/order-service";

type UseGetClaimHistoryDetailQueryParams = {
  queryParams: { publicId: string };
  options?: Omit<UseQueryOptions<GetClaimHistoryDetailResponseDto>, "queryKey">;
};

export const useGetClaimHistoryDetailQuery = ({
  queryParams,
  options
}: UseGetClaimHistoryDetailQueryParams) => {
  return useQuery({
    queryKey: OrderQueryKeys.getClaimHistoryDetail(queryParams.publicId)
      .queryKey,
    queryFn: async () =>
      await OrderService.getClaimHistoryDetail({ payload: queryParams }),
    ...options
  });
};
